module.exports = __webpack_public_path__ + "img/ico_company.a1d8067b.png";